'use client'

import React, { useState } from 'react'
import { faClose, faListUl } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/sass/menu/NavigationMenu.scss'

interface Props {
  sectionList: {
    sectionName: string | undefined;
    sectionId: string;
  }[]
  orderingActive: boolean
}

const NavigationMenu = ({ sectionList, orderingActive }: Props) => {
  const [showMenu, setShowMenu] = useState(false)

  const handleNavigate = (sectionId: string) => {
    window.location.hash = ''
    window.location.hash = sectionId
    setShowMenu(false)
  }

  return (
    <>
      {showMenu && (
        <div className='menu-overlay' onClick={() => setShowMenu(false)}>
          <article className='navigation-menu' onClick={(e) => e.stopPropagation()}>
            <ul>
              {sectionList.filter(section => section.sectionName).map((section, index) => (
                <div key={index}>
                  <li onClick={() => handleNavigate(section.sectionId)}>
                    {section.sectionName}
                  </li>
                  <hr />
                </div>
              ))}
            </ul>
          </article>
        </div>
      )}

      <div className='navigation-menu-btn' style={orderingActive ? { bottom: '100px' } : {}} onClick={() => setShowMenu(!showMenu)}>
        <FontAwesomeIcon icon={showMenu ? faClose : faListUl} />
      </div>
    </>
  )
}

export default NavigationMenu
